// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"e4-z"};